import Main from './index.vue'

export default [
  { path: '/onlinesales', component: Main, meta: { auth: true } }
]